const configEnv = {
  appTitle: import.meta.env.VITE_APP_TITLE || 'TassoMutuo Backoffice',
  environment: import.meta.env.VITE_ENVIRONMENT || 'production',
  serverBasePath: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  networkTimeout: import.meta.env.VITE_NETWORK_TIMEOUT || 30000,
  googleLoginClientId: import.meta.env.VITE_GOOGLE_LOGIN_CLIENT_ID || '',
  appVersion: import.meta.env.VITE_APP_VERSION || '',
  mixpanelId:
    import.meta.env.VITE_MIXPANELID || '817e42405e5a70a58b8928828e477617',
  mixpanelDebug: import.meta.env.VITE_MIXPANELDEBUG || false,
  tassomutuoBaseUrl:
    import.meta.env.VITE_TASSOMUTUO_BASE_URL || 'https://dev.tassomutuo.it',
  intranetBaseUrl:
    import.meta.env.VITE_INTRANET_BASE_URL || 'http://localhost:3000',
  isStage: import.meta.env.VITE_ENVIRONMENT === 'staging',
  apiUrlTassoProduction:
    import.meta.env.VITE_API_URL_TASSO_PRODUCTION || 'http://localhost:3000',
  tassoQuintoApiBaseUrl:
    import.meta.env.VITE_TASSO_QUINTO_API_URL || 'http://localhost:3010',
};

export default configEnv;
